import React from 'react';

import PropTypes from 'prop-types';

import EntitiesCacheProvider from './EntitiesCacheProvider';
import LinkedEntitiesProvider from './LinkedEntitiesProvider';
import PluginProvidersProvider from './PluginProvidersProvider';
import RelationshipsProvider from './RelationshipsProvider';
import { pluginShape, relationshipEntityShape } from '../helpers/propTypes';

const ReferencePickerProvider = ({
  children,
  sourceEntityIds,
  sourceEntityDomain,
  sourceEntityType,
  plugins,
  disableRelationshipService,
  relationshipEntitiesList,
}) => {
  return (
    <EntitiesCacheProvider>
      <RelationshipsProvider
        sourceEntityIds={sourceEntityIds}
        sourceEntityDomain={sourceEntityDomain}
        sourceEntityType={sourceEntityType}
        disableRelationshipService={disableRelationshipService}
        relationshipEntitiesList={relationshipEntitiesList}
      >
        <LinkedEntitiesProvider
          sourceEntityDomain={sourceEntityDomain}
          sourceEntityType={sourceEntityType}
          plugins={plugins}
        >
          <PluginProvidersProvider plugins={plugins}>
            {children}
          </PluginProvidersProvider>
        </LinkedEntitiesProvider>
      </RelationshipsProvider>
    </EntitiesCacheProvider>
  );
};

ReferencePickerProvider.displayName = 'ReferencePickerProvider';

ReferencePickerProvider.propTypes = {
  /**
   * The entity IDs we want to get linked entities for.
   */
  sourceEntityIds: PropTypes.arrayOf(PropTypes.string),
  /**
   * The source entity domain, as used by relationship service.
   */
  sourceEntityDomain: PropTypes.string.isRequired,
  /**
   * The source entity type, as used by relationship service.
   */
  sourceEntityType: PropTypes.string.isRequired,
  /**
   * The plugins we want to get linked entities for.
   */
  plugins: PropTypes.arrayOf(pluginShape).isRequired,
  /**
   * Whether we want to disable fetching data from relationship service (when using `relationshipEntitiesList` for example)
   */
  disableRelationshipService: PropTypes.bool,
  /**
   * This can be used when we want to use ReferencePicker with custom relationship entities source.
   */
  relationshipEntitiesList: PropTypes.arrayOf(relationshipEntityShape),
  /**
   * The content of the provider.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default ReferencePickerProvider;
